import { useMutation } from 'react-query'
import { useAuth0 } from '../../contexts/auth0-context'
import endpoints from '../../API/endpoints'
import callAPI from '../../API/callSecureAPI'

type ImportActivitiesVariables = {
    activityIds: string[]
    roadmapId: string
}

export const useImportActivitiesMutation = () => {
    const { getTokenSilently } = useAuth0()

    const importActivities = async ({ activityIds, roadmapId }: ImportActivitiesVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
        const { method } = endpoints.importActivities
        const url = `${endpoints.importActivities.url}${roadmapId}/import`

        const response = await callAPI(url, method, token, { activityIds })

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to import activities')
        }

        return response.data
    }

    return useMutation(importActivities)
}
